module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "pdfContent",
    attrs: {
      "id": "content-to-print"
    }
  }, [_c('div', {
    staticClass: "titleinfo"
  }, [_c('span', {
    staticStyle: {
      "font-size": "35px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(this.dzzsForm.zsmc))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("职业技能认定证书")])]), _vm._v(" "), _c('div', {
    staticClass: "contentinfo"
  }, [_c('span', [_vm._v("证书编号：  " + _vm._s(this.dzzsForm.zsbh))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("证书类型：  " + _vm._s(this.dzzsForm.zslx))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("行业类型：  " + _vm._s(this.dzzsForm.hylx))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("证书等级：  " + _vm._s(this.dzzsForm.zsdj))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("总       分：  " + _vm._s(this.dzzsForm.zf))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("姓       名：  " + _vm._s(this.dzzsForm.xm))])]), _vm._v(" "), _c('div', {
    staticClass: "footerinfo"
  }, [_c('span'), _c('br'), _vm._v(" "), _c('span', [_vm._v("授予日期：" + _vm._s(this.dzzsForm.syrq))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12429e63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/skillRecognition/stuServices/stuServicesDzzs.vue
// module id = 1777
// module chunks = 502